import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "social-facebook",
  "use": "social-facebook-usage",
  "viewBox": "0 0 12 22",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 12 22\" id=\"social-facebook\"><path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M11.214 12.281l.622-3.95h-3.89V5.765c0-1.081.543-2.135 2.285-2.135H12V.267S10.395 0 8.86 0C5.656 0 3.562 1.892 3.562 5.318V8.33H0v3.952h3.562v9.552a14.495 14.495 0 004.383 0V12.28h3.269z\" clip-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol